import { Component, Inject, ViewEncapsulation } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Constants, CUSTOM_SORT, EvaluationFlowsEnum } from "../../models/shared.model";

@Component({
  selector: "app-domain-dialog",
  templateUrl: "./domain-dialog.component.html",
  encapsulation: ViewEncapsulation.None
})
export class DomainDialog {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: Map<string, number>,

    public dialogRef: MatDialogRef<DomainDialog>
  ) {
    this.sort();
  }

  sort(){
    const sortedEntries = Array.from(this.data?.entries()).sort(([keyA], [keyB]) => {
      const indexA = CUSTOM_SORT.indexOf(keyA as EvaluationFlowsEnum | Constants);
      const indexB = CUSTOM_SORT.indexOf(keyB as EvaluationFlowsEnum | Constants);

      return indexA - indexB;
    });

    this.data = new Map<string, number>(sortedEntries);
  }

  asIsOrder(a, b) {
    return 1;
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
